import { render, staticRenderFns } from "./CompanyProductList.vue?vue&type=template&id=ec2c8ece&"
import script from "./CompanyProductList.vue?vue&type=script&lang=js&"
export * from "./CompanyProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports